import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  GetProjectTypesRequest,
  GetProjectTypesResponse,
  CreateProjectTypeRequest,
  CreateProjectTypeResponse,
  DeleteProjectTypeRequest,
  DeleteProjectTypeResponse,
} from "../../models/Project.model";

const API_BASE_URL = environment.apiUrl;

// קבלת סוגי פרויקטים
export const getProjectTypes = createAsyncThunk<
  GetProjectTypesResponse,
  GetProjectTypesRequest,
  { rejectValue: string }
>("projectTypes/getProjectTypes", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/GetProjectTypes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: GetProjectTypesResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to fetch project types");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// יצירה/עדכון סוג פרויקט
export const createOrUpdateProjectType = createAsyncThunk<
  CreateProjectTypeResponse,
  CreateProjectTypeRequest,
  { rejectValue: string }
>("projectTypes/createOrUpdate", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/CreateProjectType`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: CreateProjectTypeResponse = await response.json();

    if (!data.success)
      return rejectWithValue(
        data.message || "Failed to create/update project type"
      );
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});

// מחיקת סוג פרויקט
export const deleteProjectType = createAsyncThunk<
  DeleteProjectTypeResponse,
  DeleteProjectTypeRequest,
  { rejectValue: string }
>("projectTypes/delete", async (requestData, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Project/DeleteProjectType`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data: DeleteProjectTypeResponse = await response.json();

    if (!data.success)
      return rejectWithValue(data.message || "Failed to delete project type");
    return data;
  } catch (error) {
    return rejectWithValue(
      error instanceof Error ? error.message : "Unknown error"
    );
  }
});
